import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./StatsNavTabs.module.css";

const DEFAULT_TABS = [
  { label: "At a glance", hash: "#/at-a-glance" },
  { label: "Page by page", hash: "#/page-by-page" },
  { label: "Visits", hash: "#/views" },
  { label: "Unique Recipients", hash: "#/viewers" },
];

const StatsNavTabs = ({ tabs = DEFAULT_TABS }) => {
  const { hash } = useLocation();

  const activeIndex = useMemo(() => {
    const idx = tabs.findIndex((tab) => hash.includes(tab.hash.replace("#", "")));
    if (idx >= 0) return idx;

    // Sub-routes that belong to the Visits tab
    if (hash.includes("/viewer/") || hash.includes("/session/")) {
      const viewsIdx = tabs.findIndex((tab) => tab.hash === "#/views");
      if (viewsIdx >= 0) return viewsIdx;
    }

    return 0;
  }, [hash, tabs]);

  const handleKeyDown = (e, index) => {
    let targetIndex = null;

    if (e.key === "ArrowRight") {
      e.preventDefault();
      targetIndex = (index + 1) % tabs.length;
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      targetIndex = (index - 1 + tabs.length) % tabs.length;
    } else if (e.key === "Home") {
      e.preventDefault();
      targetIndex = 0;
    } else if (e.key === "End") {
      e.preventDefault();
      targetIndex = tabs.length - 1;
    }

    if (targetIndex !== null) {
      const tabElements = e.currentTarget.parentElement.querySelectorAll(
        `[role="tab"]`
      );
      tabElements[targetIndex]?.focus();
    }
  };

  return (
    <div className={`${styles.tabsWrapper} card p-2`} aria-label="Statistics navigation">
      <div className={styles.tabsList} role="tablist" aria-label="Statistics sections">
        {tabs.map((tab, index) => {
          const isActive = index === activeIndex;
          return (
            <Link
              key={tab.hash}
              to={tab.hash}
              role="tab"
              aria-selected={isActive}
              aria-controls={`panel-${tab.hash.replace("#/", "")}`}
              tabIndex={isActive ? 0 : -1}
              className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
              onKeyDown={(e) => handleKeyDown(e, index)}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default StatsNavTabs;
